import { useNavigate } from "react-router-dom";
import "./Css/ExamCreateForm.css";
import { useState } from "react";
import API_BASE from "../config/api";


const CreateCumission = () => {
      const navigate = useNavigate();
      const [showPopup, setShowPopup] = useState(false);


  return (
    <div className="create-exam-wrapper">
     <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          कमिशन व्यवस्थापन  &gt;&gt; <span>दिलेले कमिशन जोडा</span>
        </h3>

        <div className="edit-btnn">
    
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
         <button
  className="btn primaryy"
  onClick={() => navigate(-1)}
>
 सेव्ह करा 
</button>
 </div>
      </div>

      {/* Form */}
      <div className="create-exam-form">
        <div className="form-grid">
            
          <div className="form-group">
            <label>संस्थेचे नाव</label>
            <input type="text" placeholder="संस्थेचे नाव इथे टाका " />
             </div>


          <div className="form-group">
            <label>एकूण पुस्तक विक्री </label>
            <input type="text" placeholder="एकूण पुस्तक विक्री संख्या इथे टाका  " />
          </div>

          <div className="form-group">
            <label>एकूण कमिशन</label>
            <input type="text" placeholder="एकूण दिलेले कमिशन इथे टाका" />
          </div>

          <div className="form-group">
            <label>व्यवहाराची तारीख</label>
            <input type="date" placeholder="कमिशन दिलेली दिनांक " />
          </div>

          <div className="form-group">
            <label>कमिशन टक्केवारी</label>
            <input type="text" placeholder="५%" />
          </div>
         </div>
      </div>
    </div>
  );
};

export default CreateCumission;
